module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAQBJREFUaEPtmFEKwjAQRLc39SbqScSTqgsKUoQt7L6RwOSnlDTbeTMhSbvF4m1bXH8Y4N8JOgEn0HTAU6hpYHu4E2hb2CzgBHYGniLiERH3prGHh08mkOJv7zdfX9fLYRWNBymAlCSBmARI0eed8zjENIAcggCQQlAAMggSQAJBA+AQCgAUQgWAQSgBfkHk7t06dqgB8niRm92nLQWwF5/3uVO3mioBRHySKwAw8QoAVDwNgIsnASTiKQCZeAJAKn4a4PubOGuPrPPVJjG5jH4DSMRPJ5D1lv6tUqWN9E9OIURgVdQAlUN0vxOgHa7qO4HKIbrfCdAOV/WdQOUQ3f8Ef3UwMd66MaoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/r.png
// module id = iPjq
// module chunks = 26